module.exports = __webpack_public_path__ + "img/parity-ethereum.95731ad7.png";